import { RouteObject } from 'react-router-dom';
import ConsumerManagementLandingPage from './components/landing/landing';
import ConsumerDetail from './components/details/details';
import { ManualApplicationStepper } from './components/create/manualSteps';
import { ApplicationSuccessMessage } from './components/create/stepComponents/SuccessPayment';
import CreateConsumerApplication from './components/create/create';
import NewConnectionLanding from '../consumerOnboarding/components/create/create';

export interface consumerManagementRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: consumerManagementRoute[];
}

export const consumerManagementRoutes: consumerManagementRoute[] = [
    {
      path: 'cx/consumer-management',
      element: <ConsumerManagementLandingPage />,
    },
  //   {
  //     path: 'cx/consumer-management/create',
  //     element: <ConsumerAccountAddLanding />,
  //   },
  //      {
  //   path: "/cx/consumer-management/edit/:consumerId",
  //   element: <ConsumerAccountAddLanding />,
  // },
    {
      path: 'cx/consumer-management/:consumerNo',
      element: <ConsumerDetail />,
    },
    {
      path: 'cx/consumer-management/create',
      element: <CreateConsumerApplication />,
    },
    
    {
      path: 'cx/consumer-management/create/manual',
      element: <NewConnectionLanding />,
    },
    {
      path: 'cx/consumer-management/manual/success/:consumerId',
      element: <ApplicationSuccessMessage />,
    },
    {
      path: 'cx/consumer-management/manual/edit/:consumerId',
      element: <NewConnectionLanding />,
    }  
];
